import axios, {AxiosInstance} from 'axios';

export class AxiosFactory {
  static make(baseURL?: string): AxiosInstance {
    return axios.create({
      baseURL,
    });
  }
}
